import React, { Component } from 'react';

class MDitem extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  onChange = (e) => {
  };

  render() {
      let author = this.props.record.author_name;
      if(this.props.record.scholar_id) {
          author = author + '(' + this.props.record.scholar_id + ')';
      }

    return (
      <tr>
        <td>{this.props.record.ID}</td>
        <td>{this.props.record.email}</td>
        <td>{author}</td>
          <td>{this.props.record.org_name}</td>
          <td>{this.props.record.country}</td>
        <td>{this.props.record.resource_ids}</td>
        <td>{this.props.record.author_ids}</td>
        <td>{this.props.record.mail_open}</td>
        <td>{this.props.record.site_open}</td>
      </tr>
    )
  }
}

export default MDitem;